import React from 'react';
import $ from "jquery";
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Table } from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import MakeDecimalPoints from '../../makedecimalpoints';

export default class ExpenseReport extends React.Component {

    state = {
        report: [], openingBalance: 0, closingBalance: 0
    }

    ExpenseHeadeBaseReport = (fromDate, toDate) => {
        let context = this;
        context.setState({ fromDate, toDate })
        let data = { fromDate, toDate, id: this.props.item.id };
        $.ajax({
            type: 'POST', data,
            url: Server() + 'Accountings/ExpenseReport/GetExpenseReport.php',
            success: function(data) {
                let openingBalance = 0; let closingBalance = 0;
                try {
                    data = JSON.parse(data);
                    data.map((c) => {
                        openingBalance = c.opening;
                        closingBalance = c.closing;
                        data = c.data;
                    })
                    context.setState({ report: data, load: false, dialog: true, openingBalance, closingBalance })
                } catch (error) {
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                context.setState({ load: false });
            }
        });
    }


    convertIntoNumber(value) {
        try {
        value = Number(value);
        } catch (error) {
        value = 0;
        }
        return value;
    }

    makeINTODecimal(value) {
        try {
        value = value.toFixed(2);
        } catch (error) {
        value = '';
        }
        return value;
    }

    render() {
        let sino = 1;
        let closingBalance1 = 0;
        let { load, message, fromDate, toDate, dialog, openingBalance, closingBalance, report } = this.state;
        return (
            <div>
                <Loading load={load} message={message} />
                <center style={{cursor: 'pointer'}} onClick={ () => this.ExpenseHeadeBaseReport(this.props.fromDate, this.props.toDate)}>View</center>
                <Dialog fullWidth={true}  maxWidth={'lg'}
                    open={dialog} onClose={ () => { this.setState({ dialog: false }) }} 
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title">Expense</DialogTitle>
                    <DialogContent>
                        <div style={{display: 'flex'}}>
                            <TextField label="From" type="date"
                            onChange={(e) => this.setState({fromDate: e.target.value})}
                            defaultValue={fromDate} />

                            <TextField style={{marginLeft: 20}} label="To" type="date"
                            onChange={(e) => this.setState({toDate: e.target.value})}
                            defaultValue={toDate} />

                            <Button primary onClick={ () => this.ExpenseHeadeBaseReport(fromDate, toDate)} style={{marginLeft: '1%'}}>Submit</Button>
                        </div>
                        <div style={{display: 'flex', width: '100%'}}>
                            <div style={{width: '50%'}}>
                                <b>{'Opening Balance : Rs. '+this.makeINTODecimal(this.convertIntoNumber(openingBalance))}</b>
                            </div>
                            <div style={{width: '50%', textAlign: 'right'}}>
                                <b>{'Closing Balance : Rs. '+this.makeINTODecimal(this.convertIntoNumber(closingBalance))}</b>
                            </div>
                        </div>
                        <table width="100%" id="table" style={{marginTop: '0.5%'}}>
                            <tr>
                                <th id="th">Sino</th>
                                <th id="th" style={{width: '8%'}}>Payment Date</th>
                                <th id="th">Voucher</th>
                                <th id="th">Payment Mode</th>
                                <th id="th">Branch</th>
                                <th id="th">Whom</th>
                                <th id="th">Name</th>
                                <th id="th">Credit</th>
                                <th id="th">Debit</th>
                                <th id="th" style={{display: 'none'}}>Closing</th>
                            </tr>
                            {
                                report.map((c) => {
                                let amount = this.convertIntoNumber(c.amount);
                                let creditAmount = '';
                                let debitAmount = '';
                                if (amount > 0) { creditAmount = amount; closingBalance1 = closingBalance1 + amount; }
                                else { debitAmount = (amount * -1); closingBalance1 = closingBalance1 - (amount * -1); }
                                return (
                                    <tr>
                                        <td>{sino++}</td>
                                        <td><center>{c.payment_date}</center></td>
                                        <td>{c.voucher}</td>
                                        <td>{c.mode}</td>
                                        <td>{c.branch}</td>
                                        <td>{c.whom}</td>
                                        <td>{c.name}</td>
                                        <td><div style={{textAlign: 'right'}}>{this.makeINTODecimal(creditAmount)}</div></td>
                                        <td><div style={{textAlign: 'right'}}>{this.makeINTODecimal(debitAmount)}</div></td>
                                        <td style={{display: 'none'}}>
                                            { closingBalance1 > 0 ? closingBalance1 : (closingBalance1 * -1) }
                                        </td>
                                    </tr>
                                )
                                })
                            }
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}